import { styled } from '@mui/material/styles';
import { SwitchField } from '@openx/components-core/lib/SwitchField/SwitchField.tsx';
import { useFiltersContext } from '@openx/components-filters/lib/context/FiltersContext.tsx';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import type { DealPromptFilters } from '../../utils/types.ts';

type UseOnlyFreeSegmentsSwitchProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  isDisabled: boolean;
};

const StyledSwitchField = styled(SwitchField)`
  & .PrivateSwitchBase-input.MuiSwitch-input {
    left: 0;
  }
`;

export const UseOnlyFreeSegmentsSwitch = ({ checked, onChange, isDisabled }: UseOnlyFreeSegmentsSwitchProps) => {
  const { setIsFilteringDisabled } = useFiltersContext<DealPromptFilters>();
  const { t } = useTranslation();

  const handleChange = useCallback(
    (_, checked: boolean) => {
      onChange(checked);
      setIsFilteringDisabled(checked);
    },
    [onChange, setIsFilteringDisabled]
  );
  return (
    <StyledSwitchField
      data-test="details-view-show-only-free-segments"
      label={t('Use only free segments')}
      checked={checked}
      onChange={handleChange}
      disabled={isDisabled}
    />
  );
};
